/**
 * 🟦 V11.x Refactor P1 — Modal "Guardar receta" (extraído de LyonHeaderButton.jsx).
 *
 * Componente PURO. Recibe estado y handlers via props. No tiene lógica
 * propia: solo dump de JSX. Mismos testids que el inline original.
 *
 * Props:
 *  - open: boolean
 *  - onClose: () => void
 *  - onConfirm: () => void
 *  - recipeName: string
 *  - setRecipeName: (str) => void   (también limpia error en el caller)
 *  - recipeError: string | null
 *  - memory: snapshot de lyonMemory
 *  - es: boolean (idioma)
 */
import { Sparkles, X } from 'lucide-react';

const LyonSaveRecipeModal = ({
  open,
  onClose,
  onConfirm,
  recipeName,
  setRecipeName,
  recipeError,
  memory,
  es,
}) => {
  if (!open) return null;
  return (
    <div
      data-testid="lyon-save-recipe-modal"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      className="fixed inset-0 z-[90] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-slate-950 border border-slate-700/70 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="px-5 py-3 border-b border-slate-800 flex items-center justify-between bg-gradient-to-r from-amber-950/40 to-orange-950/40">
          <h3 className="text-sm font-bold text-white flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-amber-300" /> {es ? 'Guardar receta' : 'Save recipe'}
          </h3>
          <button type="button" onClick={onClose} className="p-1 rounded hover:bg-slate-800 text-slate-400 hover:text-white">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5 space-y-3">
          <label className="block">
            <span className="text-xs text-slate-300 mb-1 block">{es ? 'Nombre' : 'Name'}</span>
            <input
              type="text"
              value={recipeName}
              onChange={(e) => setRecipeName(e.target.value)}
              placeholder={es ? 'ej: card glassmorphism' : 'e.g. card glassmorphism'}
              data-testid="lyon-recipe-name-input"
              className="w-full px-3 py-2 rounded-md bg-slate-900 border border-slate-700 text-white text-sm focus:outline-none focus:border-amber-500"
              autoFocus
            />
          </label>
          <div>
            <p className="text-xs text-slate-400 mb-1.5">{es ? 'Pasos a guardar' : 'Steps to save'}:</p>
            <ol className="space-y-1 max-h-32 overflow-y-auto pr-1">
              {memory.lastActions.slice(-memory.lastPatches.length).map((a, i) => (
                <li key={i} className="text-[11px] text-slate-300 bg-slate-900/60 px-2 py-1 rounded border border-slate-800">
                  <span className="text-amber-400 font-mono mr-1.5">{i + 1}.</span>{a.text}
                </li>
              ))}
            </ol>
            <p className="text-[10px] text-slate-500 mt-2">
              {es ? 'Sobre' : 'On'} <code className="text-fuchsia-300">&lt;{memory.lastNodeContext?.tag || 'div'}&gt;</code> · {memory.lastPatches.length} {es ? 'patches' : 'patches'}
            </p>
          </div>
          {recipeError && <p className="text-xs text-red-400">{recipeError}</p>}
        </div>
        <div className="px-5 py-3 border-t border-slate-800 flex items-center justify-end gap-2 bg-slate-950/80">
          <button
            type="button"
            onClick={onClose}
            data-testid="lyon-cancel-save-recipe"
            className="px-3 py-1.5 rounded-md text-xs text-slate-300 hover:text-white hover:bg-slate-800"
          >
            {es ? 'Cancelar' : 'Cancel'}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            data-testid="lyon-confirm-save-recipe"
            className="px-4 py-1.5 rounded-md text-xs font-semibold bg-amber-600 hover:bg-amber-500 text-white"
          >
            {es ? 'Guardar receta' : 'Save recipe'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LyonSaveRecipeModal;
